import { loadLocaleMessages } from "@/i18n/index"
import { loadDesktopThemeInMobile } from "@/plugins/loadDesktopThemeInMobile"
import { NavigationGuardNext, RouteLocationNormalized } from "vue-router"
import { ModalType } from "@/constants/modalConst"
import { isMobile } from "@common_lib/base/utils/src/tools"

const replaceDomain = (newDomain: string) => {
  const { protocol, host, hash } = window.location

  if (!host.includes(".")) return

  const parts = host.split(".")

  // 判斷：如果 parts 超過 newDomain 的部分數量，代表有子域名
  const newDomainParts = newDomain.split(".")

  if (parts.length > newDomainParts.length) {
    // 保留第一個部分（第一層子域名）
    const subdomain = parts[0]
    window.location.href = `${protocol}//${subdomain}.${newDomain}/${hash}`
  } else {
    // 沒有子域名，直接使用新域名
    window.location.href = `${protocol}//${newDomain}/${hash}`
  }
}

export default async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  if (from.name === undefined && to.name === "404") {
    next({ name: "Home" })
    return
  }
  if (
    ["SystemMaintenance", "IPBlock", "404", "Horizontal", "AuthBlock"].includes(
      to.name as string
    )
  ) {
    next()

    return
  }

  await loadLocaleMessages(to)

  const authStore = useAuthStore()
  const websiteInfoStore = useWebsiteInfoStore()

  const { isLogin, certification } = storeToRefs(authStore)
  const { state: websiteInfoState } = storeToRefs(websiteInfoStore)
  const { isEnablePlayerNeedLogin, isFromApi, isFake, redirectDomain } =
    websiteInfoState.value

  if (import.meta.env.PROD && redirectDomain) {
    replaceDomain(redirectDomain)
  }

  const isNeedAuth = to.matched.some(record => record.meta.isNeedAuth)

  await loadDesktopThemeInMobile(to, from, websiteInfoState.value.webSiteCssName)

  const needAuthentication =
    (isNeedAuth || isEnablePlayerNeedLogin) &&
    !isLogin.value &&
    !websiteInfoState.value.isTempRole

  if ((needAuthentication || to.name === "Login") && (isFromApi || isFake)) {
    if (isEnablePlayerNeedLogin && to.name !== "AuthBlock") {
      next({ name: "AuthBlock" })
      return
    }

    if (!isEnablePlayerNeedLogin) {
      next(false)
      const modalStore = useModalStore()
      modalStore.openModal(ModalType.LOGIN_TO_PROCEED)
      return
    }
  }
  const unAuthRouteName = isEnablePlayerNeedLogin || isMobile() ? "Login" : "Home"

  if (
    needAuthentication &&
    !isFromApi &&
    to.name !== unAuthRouteName &&
    !certification.value.isPassLoginAPI
  ) {
    next({ name: unAuthRouteName })
    return
  }

  next()
}
